/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S6_P1Inputs */

const en_guide_json_vs_yaml_xml_s6_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The honest answer is that the right format usually depends on who or what reads it next. If a browser or an API client is on the other end, JSON is almost always the path of least resistance. If a person edits the file by hand every week, the lighter syntax of YAML tends to win. XML earns its place where you need schemas, namespaces, or you are talking to a system that already speaks it.`)
};

const ko_guide_json_vs_yaml_xml_s6_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`솔직히 말하면 적절한 형식은 다음에 그것을 읽는 대상이 누구인지에 달려 있습니다. 반대편에 브라우저나 API 클라이언트가 있다면 거의 언제나 JSON이 가장 저항이 적은 길입니다. 사람이 매주 손으로 파일을 편집한다면 가벼운 문법의 YAML이 유리합니다. XML은 스키마, 네임스페이스가 필요하거나 이미 XML을 쓰는 시스템과 대화할 때 제 몫을 합니다.`)
};

const ja_guide_json_vs_yaml_xml_s6_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正直に言えば、適切な形式はたいてい次にそれを読む相手が誰かによって決まります。相手側がブラウザや API クライアントなら、ほぼ常に JSON が最も抵抗の少ない道です。人が毎週手でファイルを編集するなら、軽い構文の YAML が有利になりがちです。XML は、スキーマや名前空間が必要なとき、あるいはすでに XML を話すシステムと対話するときに真価を発揮します。`)
};

/**
* | output |
* | --- |
* | "The honest answer is that the right format usually depends on who or what reads it next. If a browser or an API client is on the other end, JSON is almost al..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s6_p1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s6_p1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s6_p1(inputs)
	return ja_guide_json_vs_yaml_xml_s6_p1(inputs)
});